module.exports = __webpack_public_path__ + "img/plug8.ba00208f.jpg";